import React, { useEffect, useState, useCallback } from "react";
import SummaryCards from "components/dashboard/SummaryCard";
import ChartsSection from "components/dashboard/ChartsSection";
import DetailTables from "components/dashboard/DetailTables";
import RekapSection from "components/dashboard/RecapSection";
import FinanceSection from "components/dashboard/FinanceSection";
import { DashboardService } from "services/DashboardService/DashboardService";
import Dropdown from "components/Input/Dropdown";
import { FilterCard } from "components/Cards";
import DatePicker from "components/Input/DatePicker";

const INITIAL_SECTION_STATE = { data: null, error: null };

export default function DashboardExecutivePage() {
  const {
    fetchDashboardSummary,
    fetchDashboardChart,
    fetchDashboardDetail,
    fetchDashboardRekap,
    fetchDashboardKeuangan,
  } = DashboardService();

  const [periode, setPeriode] = useState("2"); // "1" Today, "2" Month, "3" Year
  const [loading, setLoading] = useState(true);
  const [sections, setSections] = useState({
    summary: INITIAL_SECTION_STATE,
    chart: INITIAL_SECTION_STATE,
    detail: INITIAL_SECTION_STATE,
    rekap: INITIAL_SECTION_STATE,
    keuangan: INITIAL_SECTION_STATE,
  });
  const periodOptions = [
    { label: "Today", value: "1" },
    { label: "This Month", value: "2" },
    { label: "This Year", value: "3" },
    { label: "Daily", value: "4" },
  ];

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const loadDashboard = useCallback(async (currentPeriode, startDate, endDate) => {
    setLoading(true);

    // Each row is independent — one failing (fetch*** returns null, and
    // DashboardService already showed the fail modal) shouldn't block the rest.
    const [summary, chart, detail, rekap, keuangan] = await Promise.all([
      fetchDashboardSummary(currentPeriode, startDate, endDate),
      fetchDashboardChart(currentPeriode, startDate, endDate),
      fetchDashboardDetail(currentPeriode, startDate, endDate),
      fetchDashboardRekap(currentPeriode, startDate, endDate),
      fetchDashboardKeuangan(currentPeriode, startDate, endDate),
    ]);

    setSections({
      summary: { data: summary, error: summary ? null : "Failed to load summary cards" },
      chart: { data: chart, error: chart ? null : "Failed to load charts" },
      detail: { data: detail, error: detail ? null : "Failed to load detail tables" },
      rekap: { data: rekap, error: rekap ? null : "Failed to load recap section" },
      keuangan: { data: keuangan, error: keuangan ? null : "Failed to load finance section" },
    });

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadDashboard(periode, startDate, endDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periode, startDate, endDate]);

  return (
    <div className="min-h-screen bg-gray-50 p-3 sm:p-6">
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
        <div className="">
          <h1 className="text-xl font-semibold text-gray-900">Dashboard Executive</h1>
          <p className="text-sm text-gray-500">Sales & rental performance summary</p>
        </div>

        <div className="flex items-center gap-3">
          <FilterCard title='Period' width='w-full sm:w-56'>
            <Dropdown
              value={periode}
              options={periodOptions}
              onChange={(e) => setPeriode(e.value)}
              placeholder="Select Period"
            />
          </FilterCard>
          {(periode == "4" &&
            <>
            <FilterCard title='Date From' width='w-full sm:w-56'>
            <DatePicker value={startDate} onChange={setStartDate} disableClock={true} />
          </FilterCard>

          <FilterCard title='Date To' width='w-full sm:w-56'>
            <DatePicker value={endDate} onChange={setEndDate} disableClock={true} />
          </FilterCard>
          </>)}
          
          {/* <button className="flex items-center gap-2 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700">
            Export
          </button> */}
        </div>
      </div>

      <div className="space-y-6">
        {/* Row 1 */}
        <SummaryCards data={sections.summary.data?.data} loading={loading} error={sections.summary.error} />

        {/* Row 2 */}
        <ChartsSection data={sections.chart.data?.data} loading={loading} error={sections.chart.error} />

        {/* Row 3 */}
        <DetailTables data={sections.detail.data?.data} loading={loading} error={sections.detail.error} />

        {/* Row 4 */}
        <RekapSection data={sections.rekap.data?.data} loading={loading} error={sections.rekap.error} />

        {/* Row 5 */}
        <FinanceSection data={sections.keuangan.data?.data} loading={loading} error={sections.keuangan.error} />
      </div>
    </div>
  );
}